import { createContext, Dispatch, SetStateAction, useContext } from 'react'

type PrimaryNavigationContextType = {
  isSearchOpen?: boolean
  setSearchOpen: Dispatch<SetStateAction<boolean>>
  isMobileCategoryBrowserOpen?: boolean
  setMobileCategoryBrowserOpen?: Dispatch<SetStateAction<boolean>>
}

export const PrimaryNavigationContext = createContext<PrimaryNavigationContextType>({
  isSearchOpen: false,
  setSearchOpen: () => { },
  isMobileCategoryBrowserOpen: false,
  setMobileCategoryBrowserOpen: () => { },
})

// Context Hook
export const usePrimaryNavigationContext = () => {
  const context = useContext(PrimaryNavigationContext)

  if (context === undefined) {
    throw new Error(
      'usePrimaryNavigationContext must be used within PrimaryNavigationContextProvider',
    )
  }

  return context
}
